import client from './index'

export interface GolfLocalizationFile {
  id: string
  original_name: string
  file_path: string
  is_active: boolean
  created_at: string
  updated_at: string
}

export const getGolfLocalizationFiles = () => {
  return client.get<GolfLocalizationFile[]>('/golf-localization-files')
}

export const uploadGolfLocalizationFile = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return client.post<GolfLocalizationFile>(
    '/golf-localization-files/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export const activateGolfLocalizationFile = (id: string) => {
  return client.patch<GolfLocalizationFile>(
    `/golf-localization-files/${id}/activate`
  )
}

export const deleteGolfLocalizationFile = (id: string) => {
  return client.delete<null>(`/golf-localization-files/${id}`)
}

export const getGolfTranslations = (lang?: string) => {
  return client.get<{
    data: Record<string, Record<string, string>> | Record<string, string>
  }>('/golf-localization', { params: lang ? { lang } : undefined })
}
